// The pain story's timing, as functions of scroll progress p (0 → 1 over the
// pinned travel; < 0 while the stage scrolls in). Shared by the text overlay
// and the 3D scene, so the two can never drift apart. No three.js here.
import { clamp01 } from './lib/ease';

/** Section height in svh: 100 for the pinned stage + 300 of travel (3 scrolls). */
export const TRACK_SVH = 400;
export const FADE = 0.04;

/** Fully visible windows for the four beats; text fades over FADE either side. */
export const BEATS = [
  { from: -1, to: 0.18 },   // S0 stakes
  { from: 0.26, to: 0.45 }, // S1 made up
  { from: 0.53, to: 0.72 }, // S2 breaks
  { from: 0.86, to: 2 },    // S3 hand-off  (0.76–0.82 is a dark beat with no text)
];
export const beatAlpha = (i: number, p: number) => {
  const b = BEATS[i];
  return clamp01((p - (b.from - FADE)) / FADE) * clamp01((b.to + FADE - p) / FADE);
};

/** S2's four pains reveal one by one. */
export const SUBS = [0.52, 0.56, 0.6, 0.64];
export const subAlpha = (j: number, p: number) => clamp01((p - SUBS[j]) / 0.03) * beatAlpha(2, p);

/** Mid-hold progress of a beat (for keyboard focus scrolling). */
export const beatMid = (i: number) => (i === 0 ? 0.05 : (Math.max(BEATS[i].from, 0) + Math.min(BEATS[i].to, 1)) / 2);

/** Scene events (all in p). */
export const EV = {
  rise: [-0.32, -0.04],
  wave: [0.02, 0.1],
  madeup: 0.22,
  flag: 0.36,
  spinner: 0.52,
  leak: [0.56, 0.64],
  tiles: [0.6, 0.63],
  pile: 0.64,
  fall: [0.7, 0.76],
  dim: [0.72, 0.76],
  recover: [0.8, 0.86],
  faceOn: [0.82, 0.85],
  greens: [0.83, 0.85, 0.87],
  connect: [0.86, 0.9],
  cited: 0.86,
  answered: 0.88,
  proactive: [0.9, 0.96],
  hop: [0.9, 0.94],
  wave2: [0.94, 0.99],
  complete: 0.97,
};
